export const specificationData = [
  {
    id: "structure",
    title: "1. Structure",
    points: [
      { type: "text", text: "R C C Framed Structure" },
      {
        type: "text",
        text: "R. C. C. framed structure to with stand Wind & Seismic Loads. (ZONE-II)",
      },
      {
        type: "text",
        text: '8" thick Solid / Porotherm blocks for external walls and 4" thick Solid / Porotherm blocks for internal walls.',
      },
    ],
  },
  {
    id: "plastering",
    title: "2. Plastering",
    points: [
      { type: "sub", text: "Internal Walls" },
      { type: "text", text: "Coat of Plastering in CM (1:6)." },
      { type: "sub", text: "External Walls" },
      {
        type: "text",
        text: "Coats of plastering in CM (1:6) for 1st coat and CM (1:4) for 2nd coat.",
      },
    ],
  },
  {
    id: "painting_cladding",
    title: "3. Painting / Cladding",
    points: [
      { type: "sub", text: "External Cladding" },
      {
        type: "text",
        text: "Tiles / Marble / Soft marble stone or equivalent, as per design."
      },

      { type: "sub", text: "External Paint Finish" },
      {
        type: "text",
        text: "Textured finish with two coats of premium exterior emulsion paint."
      },
      { type: "text", text: "Aluminium louvers as per design." },
      {
        type: "text",
        text: "Exterior-grade HPL or equivalent as per design / premium exterior-grade paint, as per design."
      },

      { type: "sub", text: "Internal" },

      { type: "sub", text: "Internal Walls" },
      {
        type: "text",
        text: "Putty over punning / gypsum plastering finished with premium-quality paint of reputed make over a coat of primer."
      },

      { type: "sub", text: "Internal Ceiling" },
      {
        type: "text",
        text: "Only primer coat provided. False ceiling is in the customer’s scope."
      },

      { type: "sub", text: "Internal – Utility / Laundry" },
      {
        type: "text",
        text: "Two coats of exterior-grade paint of reputed make over a coat of primer."
      }
    ]
  },

  {
    id: "doors_windows_railings",
    title: "4. Doors, Windows & Railings",
    points: [
      { type: "sub", text: "Main Door" },
      {
        type: "text",
        text: "High-end Hard Wood Door Frame & Shutter with veneer finish on both sides with PU coat and reputed make Designer Hardware with smart lock.",
      },
      { type: "sub", text: "Internal Doors" },
      {
        type: "text",
        text: "High end Hard Wood Door Frame & Flush Shutter with veneer finish on both sides with PU coat and reputed make Designer Hardware.",
      },
      { type: "sub", text: "French Doors, If Any" },
      {
        type: "text",
        text: "Aluminium frames with sliding shutters and hardware of reputed make.",
      },
      {
        type: "text",
        text: "Provision for a mosquito track and mosquito mesh, if required, shall be provided at an additional cost.",
      },
      { type: "sub", text: "Toilet Door" },
      {
        type: "text",
        text: "High-end hardwood Door frame and flush shutter with veneer finish on one side, finished with PU coat, and Laminate on the other side.",
      },
      { type: "sub", text: "Utility / Maid Room / Maid Toilet Doors" },
      {
        type: "text",
        text: "High end hardwood Door frame & shutter with veneer finish on one side finished with PU coat and Laminate on other side.",
      },
      { type: "sub", text: "Windows" },
      {
        type: "text",
        text: "Aluminium frames with toughened glass sliding windows and designer hardware of reputed make.",
      },
      {
        type: "text",
        text: "Provision for a mosquito track and mosquito mesh shall be provided for sliding windows only (not for casement windows).",
      },
      {
        type: "text",
        text: "Mosquito mesh, if required, shall be provided at an additional cost.",
      },
      { type: "sub", text: "Ventilators" },
      { type: "text", text: "Aluminium ventilators with premium hardware." },
      { type: "sub", text: "Sit-Out / Front Railing / Staircase" },
      { type: "text", text: "Aesthetically designed glass railing as per design." },
    ],
  },
  {
    id: "flooring",
    title: "5. Flooring",
    points: [
      {
        type: "sub",
        text: "Foyer / Drawing / Living / Dining / Lounge / Study / Pooja Room / Lobby / Children's Bedroom / Master Bedroom / Master Walk-in Closet / Bedrooms / Study Room / Other Bedrooms / Dress Room",
      },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Engineered Wooden Flooring / Skirting as per design.",
      },
      { type: "sub", text: "Home Theatre" },
      { type: "text", text: "Wooden laminated flooring." },
      { type: "sub", text: "Master / Other Bedroom Toilet / Powder Room" },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Skirting as per design.",
      },
      { type: "sub", text: "Kitchen" },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Skirting as per design.",
      },
      { type: "sub", text: "Maid Room" },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Skirting as per design.",
      },
      { type: "sub", text: "Utility" },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Skirting as per design.",
      },
      { type: "sub", text: "Maid Room Toilet" },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Skirting as per design.",
      },
      { type: "sub", text: "Store, Balcony" },
      {
        type: "text",
        text: "Vitrified Tiles flooring / Skirting as per design.",
      },
      { type: "sub", text: "Deck Area" },
      { type: "text", text: "WPC deck / Tiles as per design." },
      { type: "sub", text: "Car Porch" },
      {
        type: "text",
        text: "Cobble stone / concrete pavers / Granite as per design.",
      },
      { type: "sub", text: "Staircase" },
      { type: "text", text: "Granite as per design. / Skirting as per design." },
    ],
  },
  {
    id: "dadoing",
    title: "6. Dadoing",
    points: [
      { type: "sub", text: "Master Bed Room Toilet" },
      { type: "text", text: "Glazed Vitrified Tiles Dadoing as per design." },
      { type: "sub", text: "Other Bed Room Toilet / Powder Room" },
      { type: "text", text: "Glazed Virtified Tiles Dadoing as per design." },
      { type: "sub", text: "Wet Kitchen / Utility" },
      {
        type: "text",
        text: "Wall Cladding up to 3' height with glazed vitrified tiles and exterior grade paint above.",
      },
      { type: "sub", text: "Maid Room Toilet" },
      { type: "text", text: "Vitrified Tile Dado up to lintel height" },
    ],
  },
  {
    id: "kitchen",
    title: "7. Kitchen",
    points: [
      { type: "sub", text: "Counter" },
      {
        type: "text",
        text: "No Counter top. Open for Modular Kitchen under Customer Scope.",
      },
      { type: "sub", text: "Water Provision" },
      {
        type: "text",
        text: "Separate municipal water tap ( Manjeera or any other water proved by GHMC along with Borewell water)",
      },
      { type: "sub", text: "Other Accessories" },
      {
        type: "text",
        text: "Provision for fixing of water purifier / RO, exhaust fan / chimney.",
      },
      {
        type: "text",
        text: "Drain pipe for Refrigerator area. Provision for hot water near the sink.",
      },
    ],
  },
  {
    id: "cp_sanitary",
    title: "8. CP & Sanitary Fixtures",
    points: [
      { type: "sub", text: "Bathrooms" },
      {
        type: "text",
        text: "Premium Collection All C. P. Fittings are of reputed make.",
      },
      { type: "text", text: "Sanitary fixture of reputed make." },
      {
        type: "text",
        text: "Shower cubicle with openable / sliding doors of reputed make @ an extra cost.",
      },
      {
        type: "text",
        text: "Heat pump of suitable capacity of reputed make shall be provided for hot water for all toilets and kitchen @ an extra cost.",
      },
    ],
  },
  {
    id: "electrical",
    title: "9. Electrical Fixtures",
    points: [
      { type: "text", text: "3 phase Supply for each Villa with individual meter boards" },
      {
        type: "text",
        text: "Miniature Circuit breakers (MCB) for each distribution boards of reputed make.",
      },
      { type: "text", text: "Fire retardant low smoke wires of reputed make." },
      { type: "text", text: "Modular switches of reputed make." },
      { type: "text", text: "100% backup with DG sets." },
      { type: "text", text: "Both normal & DG power metered through energy meter." },
      { type: "sub", text: "Kitchen / Utility Area" },
      {
        type: "text",
        text: "Power plug for Cooking Range Chimney, Refrigerator, Microwave Ovens, Mixer / Grinders in Kitchen, Washing Machine and dish washer in Utility Area.",
      },
    ],
  },
  {
    id: "air_conditioning",
    title: "10. Air Conditioning Works",
    points: [
      {
        type: "text",
        text: "Power provision will be provided in all the rooms for Air conditioning Units.",
      },
      {
        type: "text",
        text: "Copper Piping, AC Units, VRV System with Cassette completely client scope.",
      },
    ],
  },
  {
    id: "telecom",
    title: "11. Telecommunications, Cable TV & Internet",
    points: [
      { type: "sub", text: "Telephone / Data" },
      {
        type: "text",
        text: "Telephone / Data Points in all bedrooms and living area and Home Theatre.",
      },
      { type: "sub", text: "Intercom Facility" },
      { type: "text", text: "One points in each bungalow (One at Ground Floor)." },
      { type: "sub", text: "Cable TV" },
      {
        type: "text",
        text: "Provision for Cable Connection in Drawing / Living & Bed Rooms and Home Theatre.",
      },
      { type: "sub", text: "Internet" },
      { type: "text", text: "Provision for FTTH (Fiber to Home) - internet." },
      { type: "sub", text: "VDP (Video Door Phone)" },
      { type: "text", text: "VDP facility will be provided at Main Door." },
    ],
  },
  {
    id: "lifts",
    title: "12. Lifts",
    points: [
      { type: "sub", text: "Passenger Lifts" },
      {
        type: "text",
        text: "Elevator shaft will be provided as per architect design. Lift client scope.",
      },
    ],
  },
  {
    id: "wsp_stp",
    title: "13. WSP & STP",
    points: [
      {
        type: "text",
        text: "Domestic Water made available through an exclusive Water Softening Plant (Not RO Plant).",
      },
      {
        type: "text",
        text: "A Sewage Treatment plant of adequate capacity as per norms will be provided inside the project, treated sewage water will be used for the landscaping.",
      },
      {
        type: "text",
        text: "Rain Water Harvesting pits in each bungalow provided for recharging ground water levels as per the norms.",
      },
      { type: "text", text: "Water meters for each unit for domestic & municipal water." },
    ],
  },
  {
    id: "ev_charging",
    title: "14. Charging Points For Electric Cars",
    points: [
      {
        type: "text",
        text: "Provision for charging point for Electric Cars shall be provided in each bungalow as per vendor's specifications (subject to Govt Guidelines).",
      },
    ],
  },
  {
    id: "power_backup",
    title: "15. Power Backup",
    points: [{ type: "text", text: "100% DG Set backup with acoustic enclosure & A. M. F." }],
  },
  {
    id: "security_bms",
    title: "16. Security / BMS",
    points: [
      { type: "text", text: "Sophisticated round - the - clock security / Surveillance System." },
      {
        type: "text",
        text: "Surveillance cameras at the main security, in open areas as per design and Common areas to monitor.",
      },
      { type: "text", text: "Solar power fencing around the site boundary compound wall. Access Control." },
      { type: "text", text: "Boom Barriers as per design." },
    ],
  },
  {
    id: "centralized_billing",
    title: "17. Centralized Billing",
    points: [
      {
        type: "text",
        text: "Billing shall be done for Consumption of Electricity and Water with prepaid meters system."
      }
    ]
  },
  {
    id: "centralized_water_supply",
    title: "18. Centralized Water Supply",
    points: [
      {
        type: "text",
        text: "A centralized underground sump will be provided for the entire community. The water shall then be supplied to individual bungalows by means of a hydro-pneumatic system."
      }
    ]
  },

  {
    id: "main_landscaping_works",
    title: "19. Main Landscaping Works",
    points: [
      {
        type: "text",
        text: "Beautifully Designed Landscaping with exclusive footpath, Activity Areas, Children's Play Area etc. is provided for the community.",
      },
      { type: "text", text: "Multipurpose court" },
      { type: "text", text: "Cricket Pitch" },
      { type: "text", text: "Kids Play Area" },
      { type: "text", text: "Outdoor Fitness Area" },
      { type: "text", text: "Amphitheatre with lawn mound" },
      { type: "text", text: "Senior citizens corner Lawn" },
    ],
  },
  {
    id: "other_landscape_amenities",
    title: "20. Other Landscape Amenities",
    points: [
      { type: "text", text: "Seaters" },
      { type: "text", text: "Interactive water feature" },
      { type: "text", text: "Sculpture" },
      { type: "text", text: "Seating pavilion" },
      { type: "text", text: "Dense planting" },
    ],
  },
  {
    id: "clubhouse_amenities",
    title: "21. Clubhouse & Amenities",
    points: [
      { type: "text", text: "Well Designed Club House with Facilities like" },
      { type: "text", text: "Multipurpose Hall" },
      { type: "text", text: "Pre-Function / Holding Area" },
      { type: "text", text: "Admin / Utility Office" },
      { type: "text", text: "Indoor Games" },
      { type: "text", text: "Table Tennis" },
      { type: "text", text: "Billiards Lounge" },
      { type: "text", text: "Badminton Court" },
      { type: "text", text: "Gym" },
      { type: "text", text: "Yoga / Aerobics" },
      { type: "text", text: "Guest Rooms (3Nos)" },
      { type: "text", text: "Spa" },
      { type: "text", text: "Temperature Pool @ Club Terrace" },
      { type: "text", text: "Party Lawn @ Club Terrace" },
    ],
  },
];
